import * as svg from "../../../assets/trash.svg";

import {iconBuilder} from "./iconBuilder";

const TrashIcon = iconBuilder(svg, "TrashIcon", "0 0 13 13");

export default TrashIcon;
